import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { theme } from '../theme';
export const LabeledComponent = ({ children, label, readOnly, required }) => (<View>
    {label && (<View style={styles.row}>
        <Text style={styles.labelField}>{label}</Text>
        {!readOnly && required && (<Text style={[styles.labelField, styles.required]}>*</Text>)}
      </View>)}
    {children}
  </View>);
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    labelField: {
        marginTop: 10,
        marginLeft: 10,
        fontWeight: 'bold',
    },
    required: {
        color: theme.colors.dangerText,
    },
});
